"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setSession = function setSession(key, sessionData) {
  sessionStorage.setItem(key, btoa(JSON.stringify(sessionData)));
};

var _default = setSession;
exports["default"] = _default;